import { AddRounded } from '@mui/icons-material';
import { Fab, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ministerFABActionButtons } from '../../store/local/contents';

export default function FragmentMinisterFAB() {
    const [showOptions, setShowOptions] = useState(false);
    const navigate = useNavigate();

    return (
        <div
            className="d-flex flex-column align-items-end"
            style={{ position: 'fixed', right: 16, bottom: 16 + 48 }}
        >
            {showOptions &&
                ministerFABActionButtons?.map(({ path, label, icon }) => (
                    <div
                        key={label + path}
                        className="d-flex align-items-center"
                        style={{ transition: 'opacity 0.5s linear' }}
                        onClick={() => navigate(path)}
                    >
                        <Typography className="bg-dark text-white mx-2 px-2">
                            {label}
                        </Typography>
                        <Fab
                            className="mb-2"
                            size="small"
                            color="secondary"
                            aria-label="add"
                        >
                            {icon}
                        </Fab>
                    </div>
                ))}
            <Fab
                size="medium"
                color="secondary"
                aria-label="add"
                onClick={() => setShowOptions(!showOptions)}
            >
                <AddRounded
                    style={{
                        transition: '200ms',
                        transform: showOptions
                            ? 'rotateZ(-45deg)'
                            : 'rotateZ(90deg)',
                    }}
                />
            </Fab>
        </div>
    );
}
